import React, { ReactElement } from 'react';
import { Text } from '@shootsta/common-react';
import quoteVideo from '../../../../../../assets/splash-quote.mp4';
import quoteThumbnail from '../../../../../../assets/images/splash-quote-thumb.png';

import './styles/_quote-block.scss';

interface QuoteBlockProps {
  quote: string;
  source?: string;
  quoteBackground?: string;
}

const QuoteBlockDefault = () => (
  <>
    <div
      className="quote-block--thumbnail"
      style={{ backgroundImage: `url(${quoteThumbnail})` }}
    />
    <div className="quote-block--video-position">
      <div className="quote-block--video-fill">
        <video loop muted autoPlay>
          <source src={quoteVideo} />
        </video>
      </div>
    </div>
  </>
);

const QuoteBlockWithBackground = ({ quoteBackground }: { quoteBackground?: string; }) => (
  <div
    className="quote-block--thumbnail"
    style={{ backgroundImage: `url(${quoteBackground})` }}
  />
);

const QuoteBlock = ({ quote, source, quoteBackground }: QuoteBlockProps): ReactElement => (
  <section className="quote-block">
    {quoteBackground
      ? <QuoteBlockWithBackground quoteBackground={quoteBackground} />
      : <QuoteBlockDefault />}
    <div className="quote-block--tint" />
    <div className="quote-block--content-container">
      <div className="quote-block--content">
        <Text
          heading1
          centered
          darkTheme
          className="quote-block--content--quote"
        >
          {quote}
        </Text>
        {source ? (
          <Text darkTheme centered>
            <b>{source}</b>
          </Text>
        ) : null}
      </div>
    </div>
  </section>
);

export default QuoteBlock;
